module.exports = __webpack_public_path__ + "img/logo.fc764e04.png";